export default __webpack_public_path__ + "static/media/MCART.68756655.svg";